<div class="user-form-page" *transloco="let t">
  <div id="login-container" class="user-form-container">
    <section id="mig-logo-panel">
      <img id="mig-perzeptron-logo" src="assets/images/Perzeptron.svg" alt="StockDB by Perzeptron">
    </section>
    <section id="login-panel">
      <img id="company-logo" src="assets/images/Perzeptron.svg" alt="Perzeptron Logo">
      <h1 id="heading-login">{{ t('Heading-Login') }}</h1>
      <error-message [(toastMessage)]="toastMessage"></error-message>

      <form id="login-form">
        <div class="input-group">
          <dx-text-box
            [(value)]="username"
            [placeholder]="t('Placeholder-Username')"
            stylingMode="outlined"
            mode="text"
          ></dx-text-box>
        </div>
        <div class="input-group">
          <dx-text-box
            [(value)]="password"
            [placeholder]="t('Placeholder-Password')"
            stylingMode="outlined"
            mode="password"
          ></dx-text-box>
        </div>

        <!-- <language-dropdown></language-dropdown> -->

        <dx-button
          [text]="t('Button-Login')"
          type="default"
          stylingMode="contained"
          class="perzeptron-button"
          [disabled]="loginButtonDisabled"
          (onClick)="onSubmit()"
        ></dx-button>
        <!-- <p class="link">{{ t('Label-No-Account') }} <a routerLink="/register">{{ t('Label-To-Register') }}</a></p>
        <p class="link">{{ t('Label-ForgotPassword') }} <a routerLink="/reset">{{ t('Label-To-Reset') }}</a></p> -->
      </form>
    </section>
  </div>
</div>
